import { disposeMesh } from 'src/utils/object3DHelpers';
import { ComponentInteractionType, Inputs, SceneComponent } from './types';

const DEFAULT_INPUTS = {
  radius: 1,
  opacity: 1,
  onClick: () => {}
};

export class TriggerComponent extends SceneComponent {
  private root: any = null;

  private pivot: any = null;

  private trigger: any = null;

  private clicked = false;

  inputs: Inputs = {
    ...DEFAULT_INPUTS
  };

  events = {
    [ComponentInteractionType.CLICK]: true,
    [ComponentInteractionType.HOVER]: true,
    [ComponentInteractionType.DRAG]: false
  };

  onInit() {
    const THREE = this.context.three;

    this.root = new THREE.Object3D();
    this.pivot = new THREE.Object3D();
    // setting the collider to add the click event
    this.outputs.collider = this.root;
    this.outputs.objectRoot = this.root;
    this.root.add(this.pivot);

    this.makeTrigger();
  }

  onDestroy() {
    if (this.trigger) {
      disposeMesh(this.trigger);
      this.trigger = null;
    }
  }

  // Called back when any inputs properties change like localPosition or localRotation
  onInputsUpdated() {
    this.onInit();
  }

  // used to fire it from outside event handler,
  // as internal handler doesn't work if outside handler is defined
  handleHover(event: any) {
    if (!this.clicked) {
      if (event.hover) {
      } else {
      }
    }
  }

  handleClick() {
    if (!this.clicked) {
      this.clicked = true;
      if (this.inputs.onClick) this.inputs.onClick(this);
    } else {
      this.clicked = false;
    }
    setTimeout(() => {
      this.clicked = false;
    }, 1000);
  }

  hide() {
    (this.trigger.material as any).opacity = 0;
  }

  private makeTrigger() {
    const THREE = this.context.three;

    if (this.trigger) {
      disposeMesh(this.trigger);
      this.trigger = null;
    }

    const geometry: any = new THREE.SphereGeometry(this.inputs.radius, 8, 8);

    const material: any = new THREE.MeshBasicMaterial({
      transparent: true,
      opacity: this.inputs.opacity,
      side: THREE.DoubleSide,
      blending: THREE.NormalBlending,
      depthWrite: false
    });

    this.trigger = new THREE.Mesh(geometry, material);
    this.pivot?.add(this.trigger);
  }
}

export const triggerComponentType = 'treedis.triggerComponent';
export const makeTriggerComponent = () => new TriggerComponent();
